<template>
    <div>
      <ListComponent />
    </div>
  </template>
<script setup lang="ts" >
import ListComponent from "../components/order-page/ListComponent.vue";

</script>